import { createApp } from "vue";
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import
import OffersListingPage from "../../common/js/components/OffersListingPage.vue";
import InitializeOffers from "../../common/js/components/InitializeOffers.vue";
import Loader from "../../common/js/components/Loader.vue";
import HongsLogo from "../../common/js/components/HongsLogo.vue";

const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded
app.component("offers-listing-page", OffersListingPage);
app.component("initialize-offers", InitializeOffers);
app.component("loader", Loader);
app.component("hongs-logo", HongsLogo);

app.mount("#themeDefaultOffers");
// @todo : uncomment this...

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
